import { courseDetails } from "./CourseDetails";
import { coursePaymentDetails } from "./CoursePaymentDetails";


export function loadTutorCourseManagement(){
    const courseId = Number($("#course-id").val());
    new courseDetails(courseId);
    new coursePaymentDetails(courseId);    
}
